/**
 * Departments List Page — ListPage with row-level Edit / Delete actions.
 */

import * as React from 'react';
import { useDelete } from '@refinedev/core';
import { useNavigate } from 'react-router';
import { ListPage, Button } from '@yesbos/ui';
import { Pencil, Trash2 } from 'lucide-react';

export function DepartmentsListPage() {
  const navigate = useNavigate();
  const { mutate: deleteRecord } = useDelete();

  const rowActions = React.useCallback((record: any) => (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 w-7 p-0"
        title="Edit"
        onClick={() => navigate(`/departments/${record.id}/edit`)}
      >
        <Pencil className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 w-7 p-0 text-destructive hover:text-destructive"
        title="Delete"
        onClick={() => {
          if (!window.confirm(`Delete department "${record.name}"? This cannot be undone.`)) return;
          deleteRecord({ resource: 'departments', id: record.id });
        }}
      >
        <Trash2 className="h-3.5 w-3.5" />
      </Button>
    </>
  ), [navigate, deleteRecord]);

  return (
    <ListPage
      collection="departments"
      title="Departments"
      basePath="/departments"
      excludeFields={['org_id', 'created_by', 'created_at', 'updated_at']}
      pageSize={25}
      rowActions={rowActions}
    />
  );
}

export default DepartmentsListPage;
